import { useQuery } from "@tanstack/react-query";

import { getRetailproductsAreRetailProductsVisible } from "api/methods";

import { usePlatform } from "./usePlatform";

export interface MyProductsVisibility {
  isMyProductsEnabled: boolean;
  isMyProductsVisibleOnMarketplace: boolean | undefined;
  isMyProductsVisible: boolean;
  isMyProductsLoading: boolean;
}

export const useMyProductsVisibility = (): MyProductsVisibility => {
  const { platform } = usePlatform();

  const { data: isMyProductsVisibleOnMarketplace, isLoading: isMyProductsLoading } = useQuery({
    ...getRetailproductsAreRetailProductsVisible.keyed(),
    staleTime: 1000 * 10,
  });

  const isMyProductsEnabled = !!platform?.platformSettings?.myProductsEnabled;

  return {
    isMyProductsEnabled,
    isMyProductsVisibleOnMarketplace,
    isMyProductsVisible: isMyProductsEnabled && !!isMyProductsVisibleOnMarketplace,
    isMyProductsLoading,
  };
};
